// Live preview of a customer's site.
//
// Most sites refuse to be framed (X-Frame-Options / frame-ancestors), so this
// renders a screenshot rather than an iframe. Microlink's free tier needs no
// key but is rate limited (~50/day per IP) — point REACT_APP_SCREENSHOT_URL at
// a paid or self-hosted renderer to lift that, using {url} as the placeholder
// for the encoded address.

// waitUntil=domcontentloaded matters: the default waits for the network to go
// idle, which never happens on sites with polling or long-lived connections.
// Those hit the renderer's 29s navigation timeout and come back as JSON with
// HTTP 408 rather than an image, so the preview just stays blank.
const SCREENSHOT_TEMPLATE =
  process.env.REACT_APP_SCREENSHOT_URL ||
  "https://api.microlink.io/?url={url}&screenshot=true&meta=false&embed=screenshot.url&waitUntil=domcontentloaded&viewport.width=1360&viewport.height=768&viewport.deviceScaleFactor=1";

export const screenshotSrc = (url) =>
  url ? SCREENSHOT_TEMPLATE.replace("{url}", encodeURIComponent(url)) : "";
